export {default} from './ai-assistant.vue'